import { render, staticRenderFns } from "./AdditNotification.vue?vue&type=template&id=288b0528&"
import script from "./AdditNotification.vue?vue&type=script&lang=js&"
export * from "./AdditNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports